import { FluidAnchorPosition, isNullOrUndefined } from '@lmig/fluid-core';
import { FunctionalComponent, h } from '@stencil/core';

import { FluidFunctionalComponentProps } from '../../../model/functional/fluid-functional-component-props.interface';
import { FluidContainer } from '../fluid-container';

interface ContainerProps extends FluidFunctionalComponentProps {
  host?: FluidContainer;
  render?: boolean;
  position?: FluidAnchorPosition;
  identifier?: string;
}

// ================================================================ //
// -- Public Functional Components

/**
 * ContainerNamedSlots - Fixed Content Slots
 */
export const ContainerNamedSlots: FunctionalComponent<ContainerProps> = (
  props: ContainerProps
) => {
  const { host } = props;

  return [
    <FixedContentSlot
      render={host._renderSlotTop}
      position={FluidAnchorPosition.TOP}
    />,
    <FixedContentSlot
      render={host._renderSlotBottom}
      position={FluidAnchorPosition.BOTTOM}
    />,
    <FixedContentSlot
      render={host._renderSlotLeft}
      position={FluidAnchorPosition.LEFT}
    />,
    <FixedContentSlot
      render={host._renderSlotRight}
      position={FluidAnchorPosition.RIGHT}
    />,
  ];
};

/**
 * ContainerNav - Embedded In-Page Nav
 */
export const ContainerNav: FunctionalComponent<ContainerProps> = (
  props: ContainerProps
) => {
  const { host, identifier, position } = props;
  const { host: pageRoot, inPageNavConfig, theme } = host;

  if (isNullOrUndefined(inPageNavConfig) || inPageNavConfig.anchor !== position)
    return;

  return (
    <fluid-in-page-nav
      class='container-nav'
      pageRoot={pageRoot}
      validInstance={true}
      data-test-id={`${identifier}-in-page-nav`}
      config={{
        theme,
        overrideGlobalTheme: true,
        ...inPageNavConfig, // Merge here to allow default "theme" to be overridden
      }}
    />
  );
};

// ================================================================ //
// -- Private Functional Components

/**
 * FixedContentSlot - Fixed Content Slot (Single Instance)
 */
const FixedContentSlot: FunctionalComponent<ContainerProps> = (
  props: ContainerProps
) => {
  const { render, position, identifier } = props;

  if (!render) return;
  return (
    <div
      class={`fixed-content-${position}`}
      data-test-id={`${identifier}-fixed-${position}`}>
      <slot
        name={`fixed-content-${position}`}
        data-test-id={`${identifier}-slot-fixed-${position}`}
      />
    </div>
  );
};
